import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import { set as setNotification } from 'store/notification/actions'
import AlarmDetailsForm from 'UserApp/components/Alarm/AlarmDetailsForm'
import { create } from 'UserApp/store/alarm/actions'
import { selectField } from 'UserApp/store/user/selectors'

class AddAlarmModelContainer extends React.PureComponent {
  static propTypes = {
    create: PropTypes.func,
    setNotification: PropTypes.func,
    onClose: PropTypes.func,
    values: PropTypes.object,
  }

  state = {
    isProcessing: false,
  }

  handleSubmit = async (formData) => {
    const startTime = new Date(formData.alarmDate);
    startTime.setHours(formData.alarmTime.getHours(), formData.alarmTime.getMinutes());
    const payload = {
      startTime: startTime,
      preAlarmReminderMinutes: formData.preAlarmReminderMinutes,
      emergencyNotificationDelayMinutes: formData.emergencyNotificationDelayMinutes,
      locationDetails: formData.locationDetails
    }
    const { create, setNotification, onClose } = this.props
    this.setState({ isProcessing: true })
    try {
      await create(payload)
      setNotification('Alarm saved successfully')
      if (onClose) onClose()
    } catch (error) {
      setNotification('Failed to save alarm details')
      console.error('Error saving alarm details:', error)
    } finally {
      this.setState({ isProcessing: false })
    }
  }

  render() {
    const { values } = this.props
    const { isProcessing } = this.state

    return (
      <AlarmDetailsForm
        values={values}
        onSubmit={this.handleSubmit}
        isProcessing={isProcessing}        
      />
    )
  }
}

export default connect(
  (state) => ({
    values: {
      alarmDate: selectField(state, 'alarmDate'),
      alarmTime: selectField(state, 'alarmTime'),
      preAlarmReminder: selectField(state, 'preAlarmReminder'),
      emergencyNotificationDelay: selectField(state, 'emergencyNotificationDelay'),
      emergencyContactDetails: selectField(state, 'emergencyContactDetails'),
    },
  }),
  {
    create,
    setNotification,
  })(AddAlarmModelContainer)
